import React from 'react'
import SbEditable from 'storyblok-react'
import Image from '../atoms/Image'
import Link from '../atoms/Link'

const LogoLinksBlock = ({ block }) => {
  return (
    <SbEditable content={block}>
      <section className="logo-links-block">
        <div className="logo-links-block-container">
          <div className="logo-links-block-wrapper">
            <div className="row">
              {block.logos?.length > 0 &&
                block.logos.map((item, index) => (
                  <div className="logo-links-block-col" key={index}>
                    <Link link={item.link}>
                      <Image
                        image={item.logo_url}
                        alt={item.alt}
                        title={item.alt}
                      />
                    </Link>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </section>
    </SbEditable>
  )
}

export default LogoLinksBlock
